// origen: D=Doméstico, T=Transnacional, G=Gobierno, P=Política
const RADIO_DATA = {
  'hrn': {
    canal: 'HRN',
    total: 6811140,
    totalSpots: 48192,
    data: [
      { pos: 1,  anunciante: 'LOTELHSA', inv: 461267, spots: 3382, origen: 'D' },
      { pos: 2,  anunciante: 'SERCOM DE HONDURAS', inv: 379380, spots: 2539, origen: 'T' },
      { pos: 3,  anunciante: 'GRUPO INTUR', inv: 320267, spots: 2028, origen: 'D' },
      { pos: 4,  anunciante: 'ROBIS', inv: 293636, spots: 1938, origen: 'D' },
      { pos: 5,  anunciante: 'FARMA FACIL', inv: 267197, spots: 1991, origen: 'D' },
      { pos: 6,  anunciante: 'COFINTER', inv: 244282, spots: 1356, origen: 'D' },
      { pos: 7,  anunciante: 'INFARMA', inv: 222609, spots: 1628, origen: 'D' },
      { pos: 8,  anunciante: 'GRUPO FINANCIERO FICOHSA', inv: 200247, spots: 1641, origen: 'D' },
      { pos: 9,  anunciante: 'BANCO ATLANTIDA', inv: 170193, spots: 1180, origen: 'D' },
      { pos: 10, anunciante: 'CATALYSIS', inv: 156975, spots: 1034, origen: 'D' },
      { pos: 11, anunciante: 'PRESTAUTO', inv: 153763, spots: 1015, origen: 'D' },
      { pos: 12, anunciante: 'CASA JAAR.', inv: 147655, spots: 1469, origen: 'D' },
      { pos: 13, anunciante: 'LABORATORIOS FARSIMAN', inv: 141746, spots: 963, origen: 'D' },
      { pos: 14, anunciante: 'CREDIMOVIL', inv: 125848, spots: 993, origen: 'D' },
      { pos: 15, anunciante: 'CONTINENTAL MOTORES', inv: 118512, spots: 796, origen: 'D' },
      { pos: 16, anunciante: 'BANCO CUSCATLAN', inv: 115299, spots: 932, origen: 'T' },
      { pos: 17, anunciante: 'BAC CREDOMATIC', inv: 108968, spots: 662, origen: 'T' },
      { pos: 18, anunciante: 'CEMCOL', inv: 105732, spots: 865, origen: 'D' },
      { pos: 19, anunciante: 'ALCALDIA DEL DISTRITO CENTRAL', inv: 97447, spots: 569, origen: 'G' },
      { pos: 20, anunciante: 'GRUPO TERRA', inv: 97282, spots: 785, origen: 'T' },
      { pos: 21, anunciante: 'HONDUBET', inv: 96462, spots: 772, origen: 'T' },
      { pos: 22, anunciante: 'PUPUSAS MIRAFLORES', inv: 92021, spots: 455, origen: 'D' },
      { pos: 23, anunciante: 'NESTLE', inv: 85627, spots: 435, origen: 'T' },
      { pos: 24, anunciante: 'UTH', inv: 85413, spots: 516, origen: 'D' },
      { pos: 25, anunciante: 'RESTAURANTE DELICIAS DEL CARMEN', inv: 84720, spots: 419, origen: 'D' },
    ],
  },
  'radio-america': {
    canal: 'RADIO AMERICA',
    total: 3079420,
    totalSpots: 33446,
    data: [
      { pos: 1,  anunciante: 'INFARMA', inv: 345774, spots: 3953, origen: 'D' },
      { pos: 2,  anunciante: 'LABORATORIOS FINLAY', inv: 310137, spots: 3044, origen: 'D' },
      { pos: 3,  anunciante: 'ESPRESSO AMERICANO', inv: 218051, spots: 1334, origen: 'D' },
      { pos: 4,  anunciante: 'SUPERMERCADOS LA COLONIA', inv: 126897, spots: 1335, origen: 'D' },
      { pos: 5,  anunciante: 'GRUPO MONGE', inv: 109014, spots: 1038, origen: 'T' },
      { pos: 6,  anunciante: 'CELTEL', inv: 100842, spots: 924, origen: 'T' },
      { pos: 7,  anunciante: 'UNIVERSIDAD DE SAN PEDRO SULA', inv: 88080, spots: 821, origen: 'D' },
      { pos: 8,  anunciante: 'HONDUBET', inv: 83978, spots: 984, origen: 'T' },
      { pos: 9,  anunciante: 'BIOKEMICAL SA DE CV', inv: 75912, spots: 673, origen: 'T' },
      { pos: 10, anunciante: 'BAC CREDOMATIC', inv: 69346, spots: 666, origen: 'T' },
      { pos: 11, anunciante: 'FARMACIAS DEL AHORRO', inv: 67356, spots: 596, origen: 'D' },
      { pos: 12, anunciante: 'BANCO ATLANTIDA', inv: 62667, spots: 660, origen: 'D' },
      { pos: 13, anunciante: 'CENOSA', inv: 60801, spots: 569, origen: 'D' },
      { pos: 14, anunciante: 'UNIMERC', inv: 58093, spots: 540, origen: 'T' },
      { pos: 15, anunciante: 'FERROMAX', inv: 54646, spots: 929, origen: 'D' },
      { pos: 16, anunciante: 'EXCEL AUTOMOTRIZ', inv: 54149, spots: 507, origen: 'T' },
      { pos: 17, anunciante: 'GRUPO SALINAS', inv: 46488, spots: 464, origen: 'T' },
      { pos: 18, anunciante: 'GRUPO TERRA', inv: 45116, spots: 493, origen: 'T' },
      { pos: 19, anunciante: 'PRESIDENCIA DE LA REPUBLICA', inv: 43120, spots: 387, origen: 'G' },
      { pos: 20, anunciante: 'DAVIVIENDA', inv: 43033, spots: 411, origen: 'T' },
      { pos: 21, anunciante: 'CASA JAAR.', inv: 41784, spots: 291, origen: 'D' },
      { pos: 22, anunciante: 'ALERGIL TRIPLE ACCION', inv: 41550, spots: 384, origen: 'D' },
      { pos: 23, anunciante: 'DIUNSA', inv: 34032, spots: 304, origen: 'D' },
      { pos: 24, anunciante: 'BETCRIS.COM', inv: 32892, spots: 307, origen: 'T' },
      { pos: 25, anunciante: 'IHCAFE', inv: 32710, spots: 181, origen: 'D' },
    ],
  },
  'radio-cadena-voces': {
    canal: 'RADIO CADENA VOCES',
    total: 2678666,
    totalSpots: 42728,
    data: [
      { pos: 1,  anunciante: 'ESPRESSO AMERICANO', inv: 368055, spots: 4286, origen: 'D' },
      { pos: 2,  anunciante: 'SUPERMERCADOS LA COLONIA', inv: 351881, spots: 6078, origen: 'D' },
      { pos: 3,  anunciante: 'CREDI RAPID', inv: 296679, spots: 4437, origen: 'D' },
      { pos: 4,  anunciante: 'GRUPO FINANCIERO FICOHSA', inv: 276425, spots: 4796, origen: 'D' },
      { pos: 5,  anunciante: 'SERCOM DE HONDURAS', inv: 266475, spots: 4708, origen: 'T' },
      { pos: 6,  anunciante: 'PARTIDO NACIONAL DE HONDURAS', inv: 155692, spots: 1728, origen: 'P' },
      { pos: 7,  anunciante: 'LA ENSENADA BEACH RESORT', inv: 110789, spots: 1912, origen: 'D' },
      { pos: 8,  anunciante: 'CELTEL', inv: 73797, spots: 1113, origen: 'T' },
      { pos: 9,  anunciante: 'BANCO DE OCCIDENTE', inv: 58964, spots: 1018, origen: 'D' },
      { pos: 10, anunciante: 'HONDUBET', inv: 58087, spots: 1161, origen: 'T' },
      { pos: 11, anunciante: 'SUPERMERCADO MI SUPER', inv: 52576, spots: 912, origen: 'D' },
      { pos: 12, anunciante: 'BANCO CUSCATLAN', inv: 45645, spots: 793, origen: 'T' },
      { pos: 13, anunciante: 'INVERSIONES LA PAZ', inv: 34102, spots: 594, origen: 'D' },
      { pos: 14, anunciante: 'PARTIDO LIBERAL DE HONDURAS', inv: 32989, spots: 367, origen: 'P' },
      { pos: 15, anunciante: 'LACTHOSA', inv: 32395, spots: 507, origen: 'D' },
      { pos: 16, anunciante: 'CACEINTOL', inv: 29582, spots: 507, origen: 'D' },
      { pos: 17, anunciante: 'BANPAIS', inv: 26822, spots: 472, origen: 'D' },
      { pos: 18, anunciante: 'PROIMA', inv: 24830, spots: 430, origen: 'D' },
      { pos: 19, anunciante: 'GRUPO SALINAS', inv: 23672, spots: 456, origen: 'T' },
      { pos: 20, anunciante: 'PRESTA YA', inv: 19927, spots: 340, origen: 'D' },
      { pos: 21, anunciante: 'CREDIMOVIL', inv: 18087, spots: 357, origen: 'D' },
      { pos: 22, anunciante: 'EMBOTELLADORA DE SULA', inv: 17893, spots: 311, origen: 'T' },
      { pos: 23, anunciante: 'MELAMINA Y ACCESORIOS GENESIS', inv: 17722, spots: 206, origen: 'D' },
      { pos: 24, anunciante: 'GRUPO TERRA', inv: 17632, spots: 306, origen: 'T' },
      { pos: 25, anunciante: 'MOTUL', inv: 17234, spots: 293, origen: 'T' },
    ],
  },
  'power-fm-sps': {
    canal: 'POWER FM SPS',
    total: 2070975,
    totalSpots: 59033,
    data: [
      { pos: 1,  anunciante: 'TACO POLLO', inv: 92201, spots: 2392, origen: 'D' },
      { pos: 2,  anunciante: 'ESPRESSO AMERICANO', inv: 75091, spots: 1329, origen: 'D' },
      { pos: 3,  anunciante: 'HELADOS YOYSY', inv: 67493, spots: 1754, origen: 'D' },
      { pos: 4,  anunciante: 'RESTAURANTE EL MORITO', inv: 64047, spots: 1668, origen: 'D' },
      { pos: 5,  anunciante: 'SUPERMERCADOS LA COLONIA', inv: 57111, spots: 1501, origen: 'D' },
      { pos: 6,  anunciante: 'HELADOS SARITA', inv: 54726, spots: 1980, origen: 'T' },
      { pos: 7,  anunciante: 'SUPER QUEQUES', inv: 54071, spots: 938, origen: 'D' },
      { pos: 8,  anunciante: 'INVERSIONES LA PAZ', inv: 49410, spots: 1287, origen: 'D' },
      { pos: 9,  anunciante: 'LARACH Y CIA', inv: 48941, spots: 1261, origen: 'D' },
      { pos: 10, anunciante: 'BANPAIS', inv: 43627, spots: 1139, origen: 'D' },
      { pos: 11, anunciante: 'PINTURAS AMERICANAS', inv: 43500, spots: 1087, origen: 'D' },
      { pos: 12, anunciante: 'GRUPO TERRA', inv: 41944, spots: 1184, origen: 'T' },
      { pos: 13, anunciante: 'SERCOM DE HONDURAS', inv: 41002, spots: 1074, origen: 'T' },
      { pos: 14, anunciante: 'UNIPHARM.', inv: 39890, spots: 895, origen: 'T' },
      { pos: 15, anunciante: 'NESTLE', inv: 38925, spots: 1670, origen: 'T' },
      { pos: 16, anunciante: 'FRIOCAR', inv: 38837, spots: 1527, origen: 'D' },
      { pos: 17, anunciante: 'GRUPO CONTINENTAL', inv: 37768, spots: 981, origen: 'D' },
      { pos: 18, anunciante: 'LABORATORIOS FARSIMAN', inv: 34887, spots: 925, origen: 'D' },
      { pos: 19, anunciante: 'CEMCOL', inv: 34267, spots: 878, origen: 'D' },
      { pos: 20, anunciante: 'DIUNSA', inv: 32740, spots: 843, origen: 'D' },
      { pos: 21, anunciante: 'CORPORACION DINANT', inv: 31883, spots: 817, origen: 'D' },
      { pos: 22, anunciante: 'CENOSA', inv: 31166, spots: 817, origen: 'D' },
      { pos: 23, anunciante: 'SMARFIT GIMNASIO', inv: 30353, spots: 630, origen: 'D' },
      { pos: 24, anunciante: 'LABORATORIOS FINLAY', inv: 25915, spots: 655, origen: 'D' },
      { pos: 25, anunciante: 'ASI NETWORK', inv: 25424, spots: 657, origen: 'D' },
    ],
  },
  'power-fm': {
    canal: 'POWER FM',
    total: 1679940,
    totalSpots: 48261,
    data: [
      { pos: 1,  anunciante: 'BAC CREDOMATIC', inv: 100739, spots: 1951, origen: 'T' },
      { pos: 2,  anunciante: 'ESPRESSO AMERICANO', inv: 76310, spots: 1377, origen: 'D' },
      { pos: 3,  anunciante: 'HELADOS YOYSY', inv: 70198, spots: 1824, origen: 'D' },
      { pos: 4,  anunciante: 'RESTAURANTE EL MORITO', inv: 65335, spots: 1701, origen: 'D' },
      { pos: 5,  anunciante: 'HELADOS SARITA', inv: 57519, spots: 2088, origen: 'T' },
      { pos: 6,  anunciante: 'SUPERMERCADOS LA COLONIA', inv: 56673, spots: 1489, origen: 'D' },
      { pos: 7,  anunciante: 'INVERSIONES LA PAZ', inv: 50249, spots: 1307, origen: 'D' },
      { pos: 8,  anunciante: 'LARACH Y CIA', inv: 50230, spots: 1294, origen: 'D' },
      { pos: 9,  anunciante: 'PINTURAS AMERICANAS', inv: 46688, spots: 1170, origen: 'D' },
      { pos: 10, anunciante: 'GRUPO TERRA', inv: 43937, spots: 1241, origen: 'T' },
      { pos: 11, anunciante: 'BANPAIS', inv: 42659, spots: 1114, origen: 'D' },
      { pos: 12, anunciante: 'SERCOM DE HONDURAS', inv: 42215, spots: 1106, origen: 'T' },
      { pos: 13, anunciante: 'PARTIDO LIBERAL DE HONDURAS', inv: 34391, spots: 539, origen: 'P' },
      { pos: 14, anunciante: 'LABORATORIOS FARSIMAN', inv: 34028, spots: 904, origen: 'D' },
      { pos: 15, anunciante: 'CEMCOL', inv: 32834, spots: 835, origen: 'D' },
      { pos: 16, anunciante: 'DIUNSA', inv: 30413, spots: 782, origen: 'D' },
      { pos: 17, anunciante: 'CORPORACION DINANT', inv: 29577, spots: 755, origen: 'D' },
      { pos: 18, anunciante: 'CENOSA', inv: 29518, spots: 773, origen: 'D' },
      { pos: 19, anunciante: 'LABORATORIOS FINLAY', inv: 27530, spots: 701, origen: 'D' },
      { pos: 20, anunciante: 'IMPRESSA REPUESTOS', inv: 24654, spots: 652, origen: 'D' },
      { pos: 21, anunciante: 'BANCO DE OCCIDENTE', inv: 24283, spots: 630, origen: 'D' },
      { pos: 22, anunciante: 'HOTEL MONTEOLIVOS', inv: 24015, spots: 624, origen: 'D' },
      { pos: 23, anunciante: 'EMBOTELLADORA DE SULA', inv: 22561, spots: 672, origen: 'T' },
      { pos: 24, anunciante: 'PROCTER AND GAMBLE', inv: 21949, spots: 722, origen: 'T' },
      { pos: 25, anunciante: 'HOTEL ANTIGUA COMAYAGUA', inv: 21444, spots: 373, origen: 'D' },
    ],
  },
  'radio-globo': {
    canal: 'RADIO GLOBO',
    total: 1631432,
    totalSpots: 39949,
    data: [
      { pos: 1,  anunciante: 'PARTIDO LIBRE', inv: 169835, spots: 3979, origen: 'P' },
      { pos: 2,  anunciante: 'COFINTER', inv: 133193, spots: 2451, origen: 'D' },
      { pos: 3,  anunciante: 'SERCOM DE HONDURAS', inv: 100714, spots: 2962, origen: 'T' },
      { pos: 4,  anunciante: 'UMAPS', inv: 89083, spots: 2217, origen: 'D' },
      { pos: 5,  anunciante: 'CACEINTOL', inv: 86388, spots: 2027, origen: 'D' },
      { pos: 6,  anunciante: 'GRUPO FINANCIERO FICOHSA', inv: 81512, spots: 2327, origen: 'D' },
      { pos: 7,  anunciante: 'INJUPEMP', inv: 79767, spots: 1618, origen: 'G' },
      { pos: 8,  anunciante: 'COACEHL', inv: 71362, spots: 1754, origen: 'D' },
      { pos: 9,  anunciante: 'ALCALDIA DEL DISTRITO CENTRAL', inv: 59291, spots: 1620, origen: 'G' },
      { pos: 10, anunciante: 'LA ENSENADA BEACH RESORT', inv: 58512, spots: 1559, origen: 'D' },
      { pos: 11, anunciante: 'LABORATORIO BIOFORMULA', inv: 51667, spots: 1491, origen: 'D' },
      { pos: 12, anunciante: 'LOTELHSA', inv: 49311, spots: 1881, origen: 'D' },
      { pos: 13, anunciante: 'PRICPHMA', inv: 48409, spots: 604, origen: 'D' },
      { pos: 14, anunciante: 'COMISION REGULADORA DE ENERGIA ELECTRICA', inv: 45889, spots: 1034, origen: 'G' },
      { pos: 15, anunciante: 'BANCO DE OCCIDENTE', inv: 34894, spots: 1012, origen: 'D' },
      { pos: 16, anunciante: 'BANCO ATLANTIDA', inv: 31447, spots: 909, origen: 'D' },
      { pos: 17, anunciante: 'CONDEPOR', inv: 29696, spots: 519, origen: 'D' },
      { pos: 18, anunciante: 'LABORATORIO MK', inv: 28440, spots: 982, origen: 'T' },
      { pos: 19, anunciante: 'BANPAIS', inv: 25773, spots: 751, origen: 'D' },
      { pos: 20, anunciante: 'INSTITUTO NACIONAL DE ESTADISTICA INE', inv: 25057, spots: 552, origen: 'D' },
      { pos: 21, anunciante: 'COPEMH', inv: 25047, spots: 256, origen: 'D' },
      { pos: 22, anunciante: 'BANRURAL', inv: 22625, spots: 649, origen: 'T' },
      { pos: 23, anunciante: 'BANADESA', inv: 21644, spots: 292, origen: 'D' },
      { pos: 24, anunciante: 'PRESIDENCIA DE LA REPUBLICA', inv: 19719, spots: 465, origen: 'G' },
      { pos: 25, anunciante: 'FUMIZA', inv: 19691, spots: 480, origen: 'D' },
    ],
  },
  'exa-fm-sps': {
    canal: 'EXA FM SPS',
    total: 999216,
    totalSpots: 37581,
    data: [
      { pos: 1,  anunciante: 'TACO POLLO', inv: 68589, spots: 2224, origen: 'D' },
      { pos: 2,  anunciante: 'SYCOM', inv: 60901, spots: 1986, origen: 'D' },
      { pos: 3,  anunciante: 'ESPRESSO AMERICANO', inv: 60334, spots: 1496, origen: 'D' },
      { pos: 4,  anunciante: 'RESTAURANTE EL MORITO', inv: 50429, spots: 1642, origen: 'D' },
      { pos: 5,  anunciante: 'SHANTI CUP CAFE', inv: 46799, spots: 1522, origen: 'D' },
      { pos: 6,  anunciante: 'HELADOS SARITA', inv: 42294, spots: 1908, origen: 'T' },
      { pos: 7,  anunciante: 'SUPERMERCADOS COLONIAL', inv: 39857, spots: 1302, origen: 'D' },
      { pos: 8,  anunciante: 'SERCOM DE HONDURAS', inv: 30995, spots: 1015, origen: 'T' },
      { pos: 9,  anunciante: 'ASI NETWORK', inv: 30910, spots: 1005, origen: 'D' },
      { pos: 10, anunciante: 'INVERSIONES CORPORATIVAS DEL ATLANTICO', inv: 29552, spots: 1020, origen: 'D' },
      { pos: 11, anunciante: 'DIUNSA', inv: 25786, spots: 829, origen: 'D' },
      { pos: 12, anunciante: 'IMPRESSA REPUESTOS', inv: 22483, spots: 734, origen: 'D' },
      { pos: 13, anunciante: 'NESTLE', inv: 18266, spots: 1215, origen: 'T' },
      { pos: 14, anunciante: 'VANA SA DE CV', inv: 16906, spots: 864, origen: 'D' },
      { pos: 15, anunciante: 'CORPORACION DINANT', inv: 16605, spots: 762, origen: 'D' },
      { pos: 16, anunciante: 'VIVA TRAVEL', inv: 16368, spots: 461, origen: 'D' },
      { pos: 17, anunciante: 'BAC CREDOMATIC', inv: 16109, spots: 502, origen: 'T' },
      { pos: 18, anunciante: 'CREDIMOVIL', inv: 15971, spots: 612, origen: 'D' },
      { pos: 19, anunciante: 'SUPER 7', inv: 15462, spots: 696, origen: 'D' },
      { pos: 20, anunciante: 'CINEMARK', inv: 15162, spots: 412, origen: 'T' },
      { pos: 21, anunciante: 'GRUPO TERRA', inv: 14928, spots: 488, origen: 'T' },
      { pos: 22, anunciante: 'EMBOTELLADORA DE SULA', inv: 14257, spots: 614, origen: 'T' },
      { pos: 23, anunciante: 'BIOKEMICAL SA DE CV', inv: 14000, spots: 458, origen: 'T' },
      { pos: 24, anunciante: 'BETCRIS.COM', inv: 13528, spots: 521, origen: 'T' },
      { pos: 25, anunciante: 'BIMBO', inv: 11956, spots: 641, origen: 'T' },
    ],
  },
  'musiquera-sps': {
    canal: 'MUSIQUERA SPS',
    total: 1040685,
    totalSpots: 22390,
    data: [
      { pos: 1,  anunciante: 'ESPRESSO AMERICANO', inv: 112608, spots: 1630, origen: 'D' },
      { pos: 2,  anunciante: 'TRULY NOLEN', inv: 70393, spots: 1153, origen: 'T' },
      { pos: 3,  anunciante: 'LARACH Y CIA', inv: 58597, spots: 1295, origen: 'D' },
      { pos: 4,  anunciante: 'POLICLINICA SAN JOSE', inv: 56254, spots: 821, origen: 'D' },
      { pos: 5,  anunciante: 'CELTEL', inv: 55466, spots: 1226, origen: 'T' },
      { pos: 6,  anunciante: 'GRUPO VANGUARDIA', inv: 53085, spots: 972, origen: 'D' },
      { pos: 7,  anunciante: 'COMERCIAL EL COMPADRE', inv: 52056, spots: 946, origen: 'D' },
      { pos: 8,  anunciante: 'HELADOS YOYSY', inv: 38373, spots: 829, origen: 'D' },
      { pos: 9,  anunciante: 'VANA SA DE CV', inv: 36588, spots: 1223, origen: 'D' },
      { pos: 10, anunciante: 'LOTELHSA', inv: 28295, spots: 804, origen: 'D' },
      { pos: 11, anunciante: 'CENOSA', inv: 28030, spots: 612, origen: 'D' },
      { pos: 12, anunciante: 'DAVIVIENDA', inv: 26072, spots: 577, origen: 'T' },
      { pos: 13, anunciante: 'ESPECIAS DON JULIO', inv: 23436, spots: 511, origen: 'D' },
      { pos: 14, anunciante: 'GRUPO TERRA', inv: 23152, spots: 502, origen: 'T' },
      { pos: 15, anunciante: 'UNIVERSIDAD DE SAN PEDRO SULA', inv: 22443, spots: 491, origen: 'D' },
      { pos: 16, anunciante: 'CREDI RAPID', inv: 21344, spots: 393, origen: 'D' },
      { pos: 17, anunciante: 'SERCOM DE HONDURAS', inv: 20384, spots: 454, origen: 'T' },
      { pos: 18, anunciante: 'MOLINO HARINERO SULA', inv: 20212, spots: 490, origen: 'D' },
      { pos: 19, anunciante: 'RAINBOW HONDURAS', inv: 18169, spots: 310, origen: 'D' },
      { pos: 20, anunciante: 'FARMACIAS DEL AHORRO', inv: 18141, spots: 366, origen: 'D' },
      { pos: 21, anunciante: 'UTH', inv: 17764, spots: 369, origen: 'D' },
      { pos: 22, anunciante: 'GRUPO MONGE', inv: 15888, spots: 360, origen: 'T' },
      { pos: 23, anunciante: 'FUNDACION HONDUREÑA DEL NIÑO CON CANCER', inv: 15347, spots: 298, origen: 'D' },
      { pos: 24, anunciante: 'GRUPO UMA', inv: 13385, spots: 488, origen: 'D' },
      { pos: 25, anunciante: 'BIOKEMICAL SA DE CV', inv: 13341, spots: 271, origen: 'T' },
    ],
  },
  'w107': {
    canal: 'W107',
    total: 1012709,
    totalSpots: 52164,
    data: [
      { pos: 1,  anunciante: 'VILLATORO FOTOCOLOR', inv: 119125, spots: 4168, origen: 'D' },
      { pos: 2,  anunciante: 'CELTEL', inv: 99568, spots: 5074, origen: 'T' },
      { pos: 3,  anunciante: 'ESPRESSO AMERICANO', inv: 89290, spots: 3181, origen: 'D' },
      { pos: 4,  anunciante: 'BAC CREDOMATIC', inv: 82010, spots: 3084, origen: 'T' },
      { pos: 5,  anunciante: 'ELECTRO CENTER', inv: 45454, spots: 1472, origen: 'D' },
      { pos: 6,  anunciante: 'GLAXO SMITHKLINE', inv: 39356, spots: 3934, origen: 'T' },
      { pos: 7,  anunciante: 'BMP SHOW', inv: 35369, spots: 1771, origen: 'D' },
      { pos: 8,  anunciante: 'DISTRIBUIDORA E INVERSIONES HOSSANA', inv: 35009, spots: 1421, origen: 'D' },
      { pos: 9,  anunciante: 'CYBERNET SCHOOL', inv: 32216, spots: 1375, origen: 'D' },
      { pos: 10, anunciante: 'SONIDO URBANO', inv: 31234, spots: 1449, origen: 'D' },
      { pos: 11, anunciante: 'VANA SA DE CV', inv: 18490, spots: 1509, origen: 'D' },
      { pos: 12, anunciante: 'DENTAL ESTHETIC CENTER', inv: 18246, spots: 492, origen: 'D' },
      { pos: 13, anunciante: 'SERCOM DE HONDURAS', inv: 16350, spots: 924, origen: 'T' },
      { pos: 14, anunciante: 'PARTIDO NACIONAL DE HONDURAS', inv: 15413, spots: 713, origen: 'P' },
      { pos: 15, anunciante: 'DAVIVIENDA', inv: 14990, spots: 807, origen: 'T' },
      { pos: 16, anunciante: 'WALMART OPERADORA DEL ORIENTE', inv: 14699, spots: 3110, origen: 'T' },
      { pos: 17, anunciante: 'GRUPO TERRA', inv: 14467, spots: 783, origen: 'T' },
      { pos: 18, anunciante: 'PLAY LAND PARK', inv: 11766, spots: 442, origen: 'D' },
      { pos: 19, anunciante: 'FERRETERIA ELIAS', inv: 11590, spots: 635, origen: 'D' },
      { pos: 20, anunciante: 'CORPORACION DINANT', inv: 11573, spots: 728, origen: 'D' },
      { pos: 21, anunciante: 'TEXACO', inv: 10613, spots: 770, origen: 'T' },
      { pos: 22, anunciante: 'SHERWIN WILLIAMS', inv: 10404, spots: 564, origen: 'T' },
      { pos: 23, anunciante: 'BUFETE MARTINEZ Y ASOCIADOS', inv: 9958, spots: 534, origen: 'D' },
      { pos: 24, anunciante: 'DAUKAN STORE', inv: 9859, spots: 526, origen: 'D' },
      { pos: 25, anunciante: 'UNIPHARM.', inv: 9668, spots: 440, origen: 'T' },
    ],
  },
  'exa-fm': {
    canal: 'EXA FM',
    total: 858845,
    totalSpots: 31943,
    data: [
      { pos: 1,  anunciante: 'BAC CREDOMATIC', inv: 65019, spots: 1625, origen: 'T' },
      { pos: 2,  anunciante: 'ESPRESSO AMERICANO', inv: 58964, spots: 1493, origen: 'D' },
      { pos: 3,  anunciante: 'RESTAURANTE EL MORITO', inv: 51614, spots: 1680, origen: 'D' },
      { pos: 4,  anunciante: 'HELADOS SARITA', inv: 44808, spots: 2024, origen: 'T' },
      { pos: 5,  anunciante: 'SERCOM DE HONDURAS', inv: 32859, spots: 1076, origen: 'T' },
      { pos: 6,  anunciante: 'INVERSIONES CORPORATIVAS DEL ATLANTICO', inv: 29880, spots: 1033, origen: 'D' },
      { pos: 7,  anunciante: 'UNIPHARM.', inv: 27076, spots: 758, origen: 'T' },
      { pos: 8,  anunciante: 'PARTIDO LIBERAL DE HONDURAS', inv: 26964, spots: 534, origen: 'P' },
      { pos: 9,  anunciante: 'CORPORACION DINANT', inv: 24974, spots: 943, origen: 'D' },
      { pos: 10, anunciante: 'DIUNSA', inv: 23662, spots: 759, origen: 'D' },
      { pos: 11, anunciante: 'IMPRESSA REPUESTOS', inv: 22886, spots: 747, origen: 'D' },
      { pos: 12, anunciante: 'GRUPO TERRA', inv: 16638, spots: 540, origen: 'T' },
      { pos: 13, anunciante: 'BMP SHOW', inv: 16586, spots: 501, origen: 'D' },
      { pos: 14, anunciante: 'GRUPO CONTINENTAL', inv: 16114, spots: 526, origen: 'D' },
      { pos: 15, anunciante: 'VIVA TRAVEL', inv: 15196, spots: 428, origen: 'D' },
      { pos: 16, anunciante: 'CINEMARK', inv: 14796, spots: 403, origen: 'T' },
      { pos: 17, anunciante: 'PEPSICO', inv: 14730, spots: 831, origen: 'T' },
      { pos: 18, anunciante: 'BETCRIS.COM', inv: 14162, spots: 541, origen: 'T' },
      { pos: 19, anunciante: 'EMBOTELLADORA DE SULA', inv: 13690, spots: 587, origen: 'T' },
      { pos: 20, anunciante: 'SUPER 7', inv: 13195, spots: 631, origen: 'D' },
      { pos: 21, anunciante: 'NESTLE', inv: 11792, spots: 797, origen: 'T' },
      { pos: 22, anunciante: 'SMARFIT GIMNASIO', inv: 11680, spots: 288, origen: 'D' },
      { pos: 23, anunciante: 'CORPORACION MAEGA', inv: 11586, spots: 373, origen: 'D' },
      { pos: 24, anunciante: 'DKT MEXICO', inv: 11554, spots: 345, origen: 'T' },
      { pos: 25, anunciante: 'BIOKEMICAL SA DE CV', inv: 11312, spots: 371, origen: 'T' },
    ],
  },
};

export default RADIO_DATA;
